//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.1.0.0 (NJsonSchema v11.0.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { AuthorizedApiBase } from './authorized-api-base'

export class CustomPermissionServiceClient extends AuthorizedApiBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    customPermission_Initiate(hQSiteId?: number, mDMClientId?: number, signal?: AbortSignal): Promise<ResponseData> {
        let url_ = this.baseUrl + "/api/v1/CustomPermission/Initiate/{HQSiteId}/{MDMClientId}";
        if (hQSiteId === undefined || hQSiteId === null)
            throw new Error("The parameter 'hQSiteId' must be defined.");
        url_ = url_.replace("{HQSiteId}", encodeURIComponent("" + hQSiteId));
        if (mDMClientId === undefined || mDMClientId === null)
            throw new Error("The parameter 'mDMClientId' must be defined.");
        url_ = url_.replace("{MDMClientId}", encodeURIComponent("" + mDMClientId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCustomPermission_Initiate(_response);
        });
    }

    customPermission_OnDemand(hQSiteId?: number, mDMClientId?: number, stepName?: string, iSheet?: string, signal?: AbortSignal): Promise<ResponseData> {
        let url_ = this.baseUrl + "/api/v1/CustomPermission/OnDemand/{HQSiteId}/{MDMClientId}/{stepName}?isheet={iSheet}";
        if (hQSiteId === undefined || hQSiteId === null)
            throw new Error("The parameter 'hQSiteId' must be defined.");
        url_ = url_.replace("{HQSiteId}", encodeURIComponent("" + hQSiteId));
        if (mDMClientId === undefined || mDMClientId === null)
            throw new Error("The parameter 'mDMClientId' must be defined.");
        url_ = url_.replace("{MDMClientId}", encodeURIComponent("" + mDMClientId));
        if (stepName === undefined || stepName === null)
            throw new Error("The parameter 'stepName' must be defined.");
        url_ = url_.replace("{stepName}", encodeURIComponent("" + stepName));
        if (iSheet !== undefined && iSheet !== null) {
            url_ = url_.replace("{iSheet}", encodeURIComponent("" + iSheet));
        }
        else {
            url_ = url_.replace("{iSheet}", encodeURIComponent("" + "All"));
        }
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCustomPermission_Initiate(_response);
        });
    }

    protected processCustomPermission_Initiate(response: Response): Promise<ResponseData> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponse<ResponseData>;
                // The endpoint returns a boolean payload; do not attempt to access a `.data` property.
                return result200.data;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400: any = null;
                result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseData>(null as any);
    }


    orchestrator_Orchestrator(customPermissionRequestMessage: CustomPermissionRequestMessage, signal?: AbortSignal): Promise<boolean> {
        let url_ = this.baseUrl + "/api/v1/Orchestrator/Orchestrator";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(customPermissionRequestMessage);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processOrchestrator_Orchestrator(_response);
        });
    }

    protected processOrchestrator_Orchestrator(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
                return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400: any = null;
                result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    customPermission_EmailNotification(hQSiteId?: number, signal?: AbortSignal): Promise<ResponseData> {
        let url_ = this.baseUrl + "/api/v1/CustomPermission/{hQSiteId}/send?force=true";
        if (hQSiteId === undefined || hQSiteId === null)
            throw new Error("The parameter 'hQSiteId' must be defined.");
        url_ = url_.replace("{hQSiteId}", encodeURIComponent("" + hQSiteId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCustomPermission_EmailNotification(_response);
        });
    }

    protected processCustomPermission_EmailNotification(response: Response): Promise<ResponseData> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponse<ResponseData>;
                return result200.data!;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400: any = null;
                result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseData>(null as any);
    }

    getCustomPermissionManagementpage(siteId: number, signal?: AbortSignal): Promise<CustomPermissionManagementpageDto> {
        if (siteId === undefined || siteId === null)
            throw new Error("The parameter 'siteId' must be defined.");

        const url_ = `${this.baseUrl}/api/v1/ManageCustomPermission/GetCustomPermissionManagementpage?siteId=${encodeURIComponent(siteId)}`;

        const options_: RequestInit = {
            method: "GET",
            headers: { "Accept": "application/json" },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then(response => this.processGetCustomPermissionManagementpage(response));
    }

    protected processGetCustomPermissionManagementpage(response: Response): Promise<CustomPermissionManagementpageDto> {
        const status = response.status;
        const headers: Record<string, string> = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => headers[k] = v);
        }

        if (status === 200) {
            return response.text().then(_responseText => {
                const result200 = JSON.parse(_responseText, this.jsonParseReviver) as ApiResponse<CustomPermissionManagementpageDto>;
                return result200.data;
            });
        }
        else if (status === 400) {
            return response.text().then(_responseText => {
                const problem = _responseText === "" ? null : JSON.parse(_responseText);
                return throwException("A server side error occurred.", status, _responseText, headers, problem);
            });
        }
        else if (status === 500) {
            return response.text().then(_responseText =>
                throwException("A server side error occurred.", status, _responseText, headers)
            );
        }
        else {
            return response.text().then(_responseText =>
                throwException("An unexpected server error occurred.", status, _responseText, headers)
            );
        }
    }
    getFolderTree(siteId: number, signal?: AbortSignal): Promise<FolderTree> {
        if (siteId === undefined || siteId === null)
            throw new Error("The parameter 'siteId' must be defined.");

        const url_ = `${this.baseUrl}/api/v1/ManageCustomPermission/FolderTree?siteId=${encodeURIComponent(siteId)}`;

        const options_: RequestInit = {
            method: "GET",
            headers: { "Accept": "application/json" },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then(response => this.processGetFolderTree(response));
    }

    protected processGetFolderTree(response: Response): Promise<FolderTree> {
        const status = response.status;
        const headers: Record<string, string> = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => headers[k] = v);
        }

        if (status === 200) {
            return response.text().then(_responseText => {
                const result200 = JSON.parse(_responseText, this.jsonParseReviver) as ApiResponse<FolderTree>;
                return result200.data;
            });
        }
        else if (status === 400) {
            return response.text().then(_responseText => {
                const problem = _responseText === "" ? null : JSON.parse(_responseText);
                return throwException("A server side error occurred.", status, _responseText, headers, problem);
            });
        }
        else if (status === 500) {
            return response.text().then(_responseText =>
                throwException("A server side error occurred.", status, _responseText, headers)
            );
        }
        else {
            return response.text().then(_responseText =>
                throwException("An unexpected server error occurred.", status, _responseText, headers)
            );
        }
    }

    legalEntityPermissions(request: CustomPermissionPayload, signal?: AbortSignal): Promise<boolean> {
        let url_ = this.baseUrl + "/api/v1/ManageCustomPermission/LegalEntityPermissions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processLegalEntityPermissions(_response);
        });
    }

    protected processLegalEntityPermissions(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
                return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400: any = null;
                result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    getLegalEntityPermissionsSchedule(siteId: number, signal?: AbortSignal): Promise<ScheduleCustomPermissionDto> {
        if (siteId === undefined || siteId === null)
            throw new Error("The parameter 'siteId' must be defined.");

        const url_ = `${this.baseUrl}/api/v1/ManageCustomPermission/LegalEntityPermissions/Schedule?siteId=${encodeURIComponent(siteId)}`;

        const options_: RequestInit = {
            method: "GET",
            headers: { "Accept": "application/json" },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then(response => this.processGetLegalEntityPermissionsSchedule(response));
    }

    protected processGetLegalEntityPermissionsSchedule(response: Response): Promise<ScheduleCustomPermissionDto> {
        const status = response.status;
        const headers: Record<string, string> = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => headers[k] = v);
        }

        if (status === 200) {
            return response.text().then(_responseText => {
                const result200 = JSON.parse(_responseText, this.jsonParseReviver) as ScheduleCustomPermissionDto & { data?: ScheduleCustomPermissionDto };
                return result200?.data ?? result200;
            });
        }
        else if (status === 400) {
            return response.text().then(_responseText => {
                const problem = _responseText === "" ? null : JSON.parse(_responseText) as ProblemDetails;
                return throwException("A server side error occurred.", status, _responseText, headers, problem);
            });
        }
        else if (status === 500) {
            return response.text().then(_responseText =>
                throwException("A server side error occurred.", status, _responseText, headers)
            );
        }
        else {
            return response.text().then(_responseText =>
                throwException("An unexpected server error occurred.", status, _responseText, headers)
            );
        }
    }

    updateLegalEntityPermissionsSchedule(request: UpdateScheduleRequest, signal?: AbortSignal): Promise<ScheduleCustomPermissionDto> {
        let url_ = this.baseUrl + "/api/v1/ManageCustomPermission/LegalEntityPermissions/Schedule";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateLegalEntityPermissionsSchedule(_response);
        });
    }

    protected processUpdateLegalEntityPermissionsSchedule(response: Response): Promise<ScheduleCustomPermissionDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ScheduleCustomPermissionDto;
                return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400: any = null;
                result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404: any = null;
                result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
                return throwException("Not found.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ScheduleCustomPermissionDto>(null as any);
    }

    getLegalEntityPermissionsScheduledCounts(signal?: AbortSignal): Promise<ScheduledCountsResult> {
        const url_ = `${this.baseUrl}/api/v1/ManageCustomPermission/LegalEntityPermissions/ScheduledCounts`;

        const options_: RequestInit = {
            method: "GET",
            headers: { "Accept": "application/json" },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then(response => this.processGetLegalEntityPermissionsScheduledCounts(response));
    }

    protected processGetLegalEntityPermissionsScheduledCounts(response: Response): Promise<ScheduledCountsResult> {
        const status = response.status;
        const headers: Record<string, string> = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => headers[k] = v);
        }

        if (status === 200) {
            return response.text().then(_responseText => {
                if (_responseText === "") {
                    return { counts: [] };
                }

                const parsed: any = JSON.parse(_responseText, this.jsonParseReviver);
                const data = parsed?.data ?? parsed;
                const counts = Array.isArray(data)
                    ? (data as ScheduledHqSiteCountByDateDto[])
                    : (Array.isArray(data?.counts) ? (data.counts as ScheduledHqSiteCountByDateDto[]) : []);

                const max = Number.isFinite(Number(data?.maxUniqueHqSiteCount)) ? Number(data.maxUniqueHqSiteCount) : undefined;

                return { counts, maxUniqueHqSiteCount: max };
            });
        }
        else if (status === 400) {
            return response.text().then(_responseText => {
                const problem = _responseText === "" ? null : JSON.parse(_responseText) as ProblemDetails;
                return throwException("A server side error occurred.", status, _responseText, headers, problem);
            });
        }
        else if (status === 500) {
            return response.text().then(_responseText =>
                throwException("A server side error occurred.", status, _responseText, headers)
            );
        }

        return response.text().then(_responseText =>
            throwException("An unexpected server error occurred.", status, _responseText, headers)
        );
    }

    report_GetActiveSites(appName?: string, signal?: AbortSignal): Promise<ActiveSites> {
        let url_ = this.baseUrl + "/api/v1/Report/sites/active";
        if (appName !== undefined && appName !== null) url_ += "?appName=" + encodeURIComponent("" + appName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processReport_GetActiveSites(_response);
        });
    }

    protected processReport_GetActiveSites(response: Response): Promise<ActiveSites> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ActiveSitesApiResponse;
                return result200.data ?? [];
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400: any = null;
                result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ActiveSites>(null as any);
    }

    report_GetSiteReport(hqSiteId?: number, appName?: string, signal?: AbortSignal): Promise<CustomPermissionSiteReportDto> {
        let url_ = this.baseUrl + "/api/v1/Report/site/{hqSiteId}?";
        if (hqSiteId === undefined || hqSiteId === null)
            throw new Error("The parameter 'hqSiteId' must be defined.");
        url_ = url_.replace("{hqSiteId}", encodeURIComponent("" + hqSiteId));
        if (appName !== undefined && appName !== null) url_ += "appName=" + encodeURIComponent("" + appName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processReport_GetSiteReport(_response);
        });
    }

    protected processReport_GetSiteReport(response: Response): Promise<CustomPermissionSiteReportDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CustomPermissionSiteReportApiResponse;
                return result200.data;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400: any = null;
                result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CustomPermissionSiteReportDto>(null as any);
    }

    report_GetStepDetailReport(hqSiteId?: number, stepName?: string, signal?: AbortSignal): Promise<CustomPermissionStepReportDto> {
        let url_ = this.baseUrl + "/api/v1/Report/site/{hqSiteId}/step/{stepName}";
        if (hqSiteId === undefined || hqSiteId === null)
            throw new Error("The parameter 'hqSiteId' must be defined.");
        url_ = url_.replace("{hqSiteId}", encodeURIComponent("" + hqSiteId));
        if (stepName === undefined || stepName === null)
            throw new Error("The parameter 'stepName' must be defined.");
        url_ = url_.replace("{stepName}", encodeURIComponent("" + stepName));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processReport_GetStepDetailReport(_response);
        });
    }

    protected processReport_GetStepDetailReport(response: Response): Promise<CustomPermissionStepReportDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CustomPermissionStepReportDto;
                return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400: any = null;
                result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CustomPermissionStepReportDto>(null as any);
    }

    report_GetEntityHistory(hqSiteId?: number, entityId?: number, stepName?: string, iSheet?:string, signal?: AbortSignal): Promise<CustomPermissionEntityHistroryApiResponse> {
        let url_ = this.baseUrl + "/api/v1/Report/site/{hqSiteId}/entity/{entityId}/step/{stepName}/{iSheet}/history";
        if (hqSiteId === undefined || hqSiteId === null)
            throw new Error("The parameter 'hqSiteId' must be defined.");
        url_ = url_.replace("{hqSiteId}", encodeURIComponent("" + hqSiteId));
        if (entityId === undefined || entityId === null)
            throw new Error("The parameter 'entityId' must be defined.");
        url_ = url_.replace("{entityId}", encodeURIComponent("" + entityId));
        if (stepName === undefined || stepName === null)
            throw new Error("The parameter 'stepName' must be defined.");
        if (iSheet !== undefined && iSheet !== null) {
            url_ = url_.replace("{iSheet}", encodeURIComponent("" + iSheet));
        }
        else {
            url_ = url_.replace("{iSheet}", encodeURIComponent("" + "All"));
        }
        url_ = url_.replace("{stepName}", encodeURIComponent("" + stepName));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processReport_GetEntityHistory(_response);
        });
    }

    protected processReport_GetEntityHistory(response: Response): Promise<CustomPermissionEntityHistroryApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CustomPermissionEntityHistroryApiResponse;
                return result200 ?? [];
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400: any = null;
                result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CustomPermissionEntityHistroryApiResponse>(null as any);
    }

    retry_RetryFailed(hqSiteId?: number, mdmClientId?: number, stepName?: string, signal?: AbortSignal): Promise<RetryFailedResponse> {
        let url_ = this.baseUrl + "/api/v1/Retry?";
        if (hqSiteId === undefined || hqSiteId === null)
            throw new Error("The parameter 'hqSiteId' must be defined.");
        url_ += "hqSiteId=" + encodeURIComponent("" + hqSiteId) + "&";
        if (mdmClientId === undefined || mdmClientId === null)
            throw new Error("The parameter 'mdmClientId' must be defined.");
        url_ += "mdmClientId=" + encodeURIComponent("" + mdmClientId) + "&";
        if (stepName === undefined || stepName === null)
            throw new Error("The parameter 'stepName' must be defined.");
        url_ += "stepName=" + encodeURIComponent("" + stepName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processRetry_RetryFailed(_response);
        });
    }

    protected processRetry_RetryFailed(response: Response): Promise<RetryFailedResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RetryFailedResponse;
                return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400: any = null;
                result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RetryFailedResponse>(null as any);
    }
}

export interface ProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;

    [key: string]: any;
}
export interface ResponseData {
    success?: boolean;
    message?: string;
}
export interface ApiResponse<T> {
    statusCode: number;
    message: string;
    data: T;
}
export interface ActiveSitesApiResponse {
    statusCode?: number;
    message?: string;
    data?: ActiveSites;
}
export interface ActiveSites {
    hqSiteId: number,
    mdmClientId: number,
    hqClientName: string,
    status: string,
    lastModifiedBy: string,
    lastModified: string,
    isCustomPermissionApplied: boolean
}
export interface CustomPermissionSiteReportApiResponse {
    statusCode?: number;
    message?: string;
    data?: CustomPermissionSiteReportDto;
}
export interface CustomPermissionSiteReportDto {
    hqSiteId: number,
    steps: [
        {
            stepName: string,
            status: string,
            totalEntities: number,
            passedEntities: number,
            failedEntities: number,
            iSheetReports: [
                {
                    iSheetName: string,
                    status: string,
                    totalEntities: number,
                    passedEntities: number,
                    failedEntities: number,
                    entities: [
                        {
                            entityId: number,
                            entityName: string,
                            status: string,
                            message: string,
                            lastUpdated: string
                        }
                    ]
                }
            ],
            entities: [
                {
                    entityId: number,
                    entityName: string,
                    status: string,
                    message: string,
                    lastUpdated: string
                }
            ]
        }
    ]
}

export interface CustomPermissionStepReportDto {
    [key: string]: any;
}
export interface CustomPermissionEntityHistroryApiResponse {
    statusCode?: number;
    message?: string;
    data?: [
        {
            stepTransactionId: number,
            status: string,
            message: string,
            createdDate: string,
            itemType: string,
            itemId: number,
            subItemId: number
        }
    ]
}

export interface RetryFailedResponse {
    success?: boolean;
    resetCount?: number;
    publishedMessages?: number;
    results?: any;
}

export interface CustomPermissionRequestMessage {
    eventType?: ServiceBusEnum;
    hqSiteId?: number;
    mdmClientId?: number;
    batchId?: number;
    userName?: string;
    correlationId?: string;
    customPermissionStepName?: string;
}

export enum ServiceBusEnum {
    CUSTOM_PERMISSION_MICRO_SERVICE = 201,
}


export interface FolderNode {
  folderId: number;
  isRestricted?: boolean;
    isChanged?: boolean;
    scheduledPublishDate?: string | null;
    publishedDate?: string | null;
    publishStatus?: string | null;
    lastModifiedBy?: string | null;
    dateModified?: string | null;
  parentFolderId: number | null;
  folderName: string;
  entityId: number;
  usersCount?: number;      
  users: string[];        
  children: FolderNode[];
  isCountryGroup?: boolean;
}

export type FolderTree = FolderNode[];

export interface UserPerSite {
  hqSiteId: number
  userId: string
  username: string
  userEmail: string
  userGroup: string
  roleId: string
  userRole: string
  userAssignmentType: string
}

export interface Entity {
  entityId: number
  entityName: string
  lastModifiedBy: string
  dateModified: string
  isRestricted: boolean
    isChanged?: boolean
    scheduledPublishDate?: string | null
    publishedDate?: string | null
    publishStatus?: string | null
  numberOfUsers: number
  userList: string[]
  folderTree: FolderTree
}

export interface CustomPermissionManagementpageDto {
  entities: Entity[];
  usersPerSite: UserPerSite[];
}

export interface CustomPermissionPayload {
  hqSiteId: number;
  scheduledDate ?: string;
  scheduleStatus ?: string;
  entities: EntityPermission[];
}

export interface EntityPermission {
  entityId: number;
    isChanged?: boolean;
    changedFolderIds?: number[];
  folderId?: number;
  folderID?: number;
  restricted: boolean;
  userList: UserList;
  folderDetails: FolderDetails;
}

export interface UserList {
  [userId: string]: string;
}

export interface FolderDetails {
  [folderId: string]: UserList;
}

export interface ScheduleCustomPermissionDto {
  siteId?: number;
  scheduledDate?: string;
  status?: string;
}

export interface UpdateScheduleRequest {
  siteId: number;
  scheduledDate?: string;
  status: string;
}

export interface ScheduledHqSiteCountByDateDto {
    date: string;
    uniqueHqSiteCount: number;
}

export interface ScheduledCountsResult {
    counts: ScheduledHqSiteCountByDateDto[];
    maxUniqueHqSiteCount?: number;
}

export interface SiteLevelReportGetResponse {
    statusCode: number | undefined;
    message: string | undefined;
    data?: SiteLevelReportGet | undefined;
}

export interface SiteLevelReportGet {
    hqSiteId: number;
    steps: Step[];
}

export interface Step {
    stepName: string;
    status: StepStatus;
    totalEntities: number;
    passedEntities: number;
    failedEntities: number;
    iSheetReports: ISheetReport[] | null;
    entities: Entity[];
}

export type StepStatus = "PASSED" | "FAILED" | "PARTIAL" | "UNKNOWN" | "PENDING";

export interface ISheetReport {
    // add structure here if you obtain it
}

export interface Entity {
    entityId: number;
    entityName: string;
    status: EntityStatus;
    message: string;
    lastUpdated: string; // ISO timestamp
    history: HistoryEntry[];
}

export type EntityStatus = "SUCCESS" | "FAILED" | "PENDING" | "UNKNOWN";

export interface HistoryEntry {
    // add fields if history entries contain more info
}

export interface DemandProcessRunResponse {
    statusCode: number;
    message: string;
    data: DemandProcessRunData;
}

export interface DemandProcessRunData {
    success: boolean;
    message: string;
}


export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}